var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0.638318V23.3402H17.3073V21.2165C16.4802 22.148 15.4524 22.8811 14.3008 23.361C13.1492 23.8409 11.9036 24.0552 10.6572 23.9879C4.81705 23.9879 0 18.7637 0 11.9999C0 5.23603 4.81705 0.0118399 10.6572 0.0118399C11.9035 -0.0547135 13.1489 0.159945 14.3003 0.639807C15.4518 1.11967 16.4797 1.85235 17.3073 2.78321V0.659554L24 0.638318ZM17.3073 11.9893C17.3652 11.2676 17.2687 10.5419 17.0243 9.86018C16.78 9.17841 16.3932 8.55606 15.8896 8.03422C15.386 7.51238 14.777 7.10292 14.1028 6.8329C13.4287 6.56287 12.7047 6.43842 11.9787 6.46775C11.2527 6.43842 10.5287 6.56287 9.85454 6.8329C9.18038 7.10292 8.57139 7.51238 8.06778 8.03422C7.56417 8.55606 7.17741 9.17841 6.93302 9.86018C6.68864 10.5419 6.59221 11.2676 6.65009 11.9893C6.59249 12.7118 6.68896 13.4384 6.93316 14.1212C7.17737 14.804 7.56378 15.4276 8.06702 15.9511C8.57026 16.4745 9.17894 16.886 9.8531 17.1585C10.5273 17.4309 11.2516 17.5582 11.9787 17.532C15.0693 17.4895 17.3073 15.3659 17.3073 11.9893Z",
    fill: "#2026D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7819C12.5565 14.7925 13.1035 14.6377 13.5714 14.3373C14.0393 14.0369 14.4068 13.6046 14.6271 13.0953C14.8475 12.586 14.9106 12.0229 14.8086 11.4778C14.7065 10.9326 14.4439 10.4301 14.0541 10.0342C13.6643 9.6383 13.165 9.36701 12.6199 9.25488C12.0748 9.14276 11.5086 9.19487 10.9933 9.40459C10.478 9.6143 10.0371 9.97212 9.72672 10.4324C9.41632 10.8928 9.2505 11.4347 9.2504 11.9893C9.24618 12.3527 9.31403 12.7134 9.45006 13.0507C9.58608 13.3879 9.78761 13.6951 10.0431 13.9546C10.2985 14.214 10.6029 14.4207 10.9387 14.5627C11.2745 14.7046 11.6352 14.7791 12 14.7819Z",
    fill: "#62E1FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlan);
export default __webpack_public_path__ + "static/media/atlan.d055fd10a2f7196d0cdcbe0190eacdee.svg";
export { ForwardRef as ReactComponent };